export const portalElement = () => document.getElementById("portal")!;
